import { useOutletContext } from 'react-router-dom';

import type { ConnectionRefs } from 'common/interfaces';

export const useConnectionRefs = () => {
  return useOutletContext<ConnectionRefs>();
};
